import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0e6828fc&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/var/www/linza-front/linza-front-20251114081013/components/common/Header.vue').default,Footer: require('/var/www/linza-front/linza-front-20251114081013/components/common/Footer.vue').default,DialogLoading: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogLoading.vue').default,DialogAuthorizationMyAcuvue: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogAuthorizationMyAcuvue.vue').default,DialogErrorNotification: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogErrorNotification.vue').default,DialogSendQuestNotification: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogSendQuestNotification.vue').default,DialogSwiper: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogSwiper.vue').default,DialogNotAvaibleNotification: require('/var/www/linza-front/linza-front-20251114081013/components/common/DialogNotAvaibleNotification.vue').default,OwlFakeWidget: require('/var/www/linza-front/linza-front-20251114081013/components/common/OwlFakeWidget.vue').default})
